<template>
  <div class="home-base">

    <!-- 头部导航 -->
    <div class="shortcut">
      <div v-if="$route.meta.footer.show && showFooter == 1" class='common-footer-wrap'>

        <div class="username" v-if="user">
          {{ $t('Username') }}: <span style="color: #e93b3d;">{{ user ? user.member_name : $t('Login') }}</span>
        </div>
        <div class="username" v-else>
          <span style="color: #e93b3d;">{{ $t('Login') }}</span>
        </div>

        <mt-tabbar v-model='home_selected' class="common-footer">

          <mt-tab-item class='item-wrap button' :class="{ 'active': $route.name == 'HomeIndex' }" id='home_index'>
            <router-link :to="{ name: 'HomeIndex' }" class='item'>
              <img src="../../assets/image/tab/icon_home_pre.png" class="image" v-if="$route.name == 'HomeIndex'">
              <img v-else src="../../assets/image/tab/icon_home_nor.png" class="image" />
              <span class='text'>{{ $t('Home') }}</span>
            </router-link>
          </mt-tab-item>

          <mt-tab-item class='item-wrap button' :class="{ 'active': $route.name == 'HomeGoodsclass' }"
            id='home_goodsclass'><router-link :to="{ name: 'HomeGoodsclass' }" class='item'><img
                src="../../assets/image/tab/icon_classify_pre.png" class="image"
                v-if="$route.name == 'HomeGoodsclass'"><img v-else src="../../assets/image/tab/icon_classify_nor.png"
                class="image" /><span class='text'>
                {{ $t('Category') }}</span></router-link></mt-tab-item>

          <mt-tab-item class='item-wrap button' :class="{ 'active': $route.name == 'GiftSave' }"
            id='home_search'><router-link :to="{ name: 'GiftSave' }" class='item'><img
                src="../../assets/image/tab/Recycle_pre.png" class="image" v-if="$route.name == 'GiftSave'"><img v-else
                src="../../assets/image/tab/Recycle.png" class="image" /><span class='text'>{{ $t('Recycle')
                }}</span></router-link></mt-tab-item>

          <mt-tab-item class='item-wrap button' :class="{ 'active': $route.name == 'HomeGoBuy' }"
            id='home_search'><router-link :to="{ name: 'HomeGoBuy' }" class='item'><img
                src="../../assets/image/tab/Recycle_pre.png" class="image" v-if="$route.name == 'HomeGoBuy'"><img v-else
                src="../../assets/image/tab/Recycle.png" class="image" /><span class='text'>{{ $t('BlindBox')
                }}</span></router-link></mt-tab-item>

          <mt-tab-item class='item-wrap button' :class="{ 'active': $route.name == 'HomeCart' }" id='home_cart'>
            <router-link :to="{ name: 'HomeCart' }" class='item'>
              <img src="../../assets/image/tab/icon_shopping_pre.png" class="image" v-if="$route.name == 'HomeCart'">
              <img v-else src="../../assets/image/tab/icon_shopping_nor.png" class="image" />
              <span class='text'>{{ $t('Cart') }}</span>
              <!-- <span class="icon" v-if="cartNumber > 0">{{ getCarCount }}</span> -->
            </router-link>
          </mt-tab-item>

          <mt-tab-item class='item-wrap button' :class="{ 'active': $route.name == 'HomeLang' }"
            id='member_index'><router-link :to="{ name: 'HomeLang' }" class='item'><img
                src="../../assets/image/tab/icon_mine_pre.png" class="image" v-if="$route.name == 'HomeLang'"><img v-else
                src="../../assets/image/tab/icon_mine_nor.png" class="image" /><span class='text'>
                {{ $t('Language selection') }}</span></router-link></mt-tab-item>

          <mt-tab-item class='item-wrap button' :class="{ 'active': $route.name == 'MemberIndexIndex' }"
            id='member_index'><router-link :to="{ name: 'MemberIndexIndex' }" class='item'><img
                src="../../assets/image/tab/icon_mine_pre.png" class="image" v-if="$route.name == 'MemberIndexIndex'"><img
                v-else src="../../assets/image/tab/icon_mine_nor.png" class="image" /><span class='text'>{{ $t('Mine')
                }}</span></router-link></mt-tab-item>

        </mt-tabbar>

      </div>
    </div>

    <router-view class="home-view" />

    <!-- 底部 -->
    <div v-if="$route.meta.footer.show && showFooter == 1" class="foot">
      <div class="copyright">

        <div class="c-list">
          <div class="item" @click="gotoFuwenben(2, 'account')">
            <div class="t">{{ $t('Account correlation') }}</div>
            <div class="text" v-for="item in  bomList1">{{ item.question }}</div>
          </div>
          <div class="item" @click="gotoFuwenben(2, 'order')">
            <div class="t">{{ $t('Order management') }}</div>
            <div class="text" v-for="item in  bomList2">{{ item.question }}</div>
          </div>
          <div class="item" @click="gotoFuwenben(2, 'pay')">
            <div class="t">{{ $t('Payment method') }}</div>
            <div class="text" v-for="item in  bomList3">{{ item.question }}</div>
          </div>
          <div class="item" @click="gotoFuwenben(2, 'shipping')">
            <div class="t">{{ $t('Shipping and distribution') }}</div>
            <div class="text" v-for="item in  bomList4">{{ item.question }}</div>
          </div>
          <div class="item" @click="gotoFuwenben(2, 'refund')">
            <div class="t">{{ $t('Return and exchange policy') }}</div>
            <div class="text" v-for="item in  bomList5">{{ item.question }}</div>
          </div>
          <div class="item" @click="gotoFuwenben(2, 'service')">
            <div class="t">{{ $t('Customer service') }}</div>
            <div class="text" v-for="item in  bomList6">{{ item.question }}</div>

            <div class="text" @click.stop="gotoFuwenben(1)">{{ $t('About Us') }}</div>
            <div class="text" @click.stop="getEmail">{{ $t('Contact us') }}</div>
          </div>
          <div class="item" @click="gotoFuwenben(2, 'security')">
            <div class="t">{{ $t('Privacy Policy and Terms of Use') }}</div>
            <div class="text" v-for="item in  bomList7">{{ item.question }}</div>
          </div>
        </div>

        <div class="icons">
          <div class="icon" v-for="item in iconList">
            <a :href="item.link" target="_blank">
              <img :src="item.src">
            </a>
          </div>
        </div>
        <div class="item" style="margin: 0;">
          <div class="text">{{ $t('address') }}: {{ '4255 South Buckley Road #1296 Aurora CO 80013 USA' }}</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { cartQuantity } from '../../api/homecart'
import { getAboutContent } from '../../api/homeArticle'
import { get_contact_info } from '../../api/homeindex'
export default {
  name: 'HomeBase',
  data() {
    return {
      home_selected: 'home_index',
      cartNumber: 0,

      bomList1: [],
      bomList2: [],
      bomList3: [],
      bomList4: [],
      bomList5: [],
      bomList6: [],
      bomList7: [],
      iconList: [
        {
          src: require('../../assets/image/home/b1.png'),
          type: 'Facebook'
        },
        {
          src: require('../../assets/image/home/b2.png'),
          type: 'Twitter'
        },
        {
          src: require('../../assets/image/home/b3.png'),
          type: 'YouTube'
        },
        {
          src: require('../../assets/image/home/b4.png'),
          type: 'Instagram'
        },
        {
          src: require('../../assets/image/home/b5.png'),
          type: 'LinkedIn'
        },
        {
          src: require('../../assets/image/home/b6.png'),
          type: 'TikTok'
        },
      ],
    }
  },
  computed: {
    ...mapState({
      user: state => state.member.info,
      isOnline: state => state.member.isOnline,
      showSpecialFooter: state => state.home.showSpecialFooter
    }),
    showFooter() {
      if (this.$route.name == 'HomeIndex' || this.$route.name == 'HomeSpecial' || this.$route.name == 'HomeActivitydetail') {
        return this.showSpecialFooter
      } else {
        return true
      }
    },
    getCarCount() {
      if (this.cartNumber > 0 && this.cartNumber < 100) {
        return this.cartNumber
      } else if (this.cartNumber >= 100) {
        return '99+'
      }
    }
  },
  created: function () {
    if (this.$route.query.inviter_id) {
      this.memberInviterId({ inviterId: this.$route.query.inviter_id })
    }
    this.getCartCount()
  },
  mounted() {
    getAboutContent('account').then(res => {
      this.bomList1 = res.result.list
    })
    getAboutContent('order').then(res => {
      this.bomList2 = res.result.list
    })
    getAboutContent('pay').then(res => {
      this.bomList3 = res.result.list
    })
    getAboutContent('shipping').then(res => {
      this.bomList4 = res.result.list
    })
    getAboutContent('refund').then(res => {
      this.bomList5 = res.result.list
    })
    getAboutContent('service').then(res => {
      this.bomList6 = res.result.list
    })
    getAboutContent('security').then(res => {
      this.bomList7 = res.result.list
    })

    get_contact_info().then(res => {
      // this.list = res.result.goods_list
      // 遍历 iconList 并添加 link 属性
      this.iconList.forEach(icon => {
        // 查找与 type 匹配的链接
        const link = res.data[icon.type];
        // 如果找到了链接，则添加到当前 icon 对象
        if (link) {
          icon.link = link;
        }
      });
    })
  },
  methods: {
    ...mapMutations({
      memberInviterId: 'memberInviterId'
    }),
    gotoFuwenben(id, type) {
      this.$router.push({ name: 'HomeDocument', query: { id: id, type: type } })
    },
    getCartCount() {
      if (this.isOnline) {
        cartQuantity().then(res => {
          if (res) {
            this.cartNumber = res.result.cart_count
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.home-view {
  width: 1210px !important;
  min-height: calc(100vh - 385px);
  margin: 0 auto;
}

.shortcut {
  right: 0;
  top: 0;
  left: 0;
  // position: fixed;
  z-index: 99;
  background: #e3e4e5;
}

.common-footer-wrap {
  margin: auto;
  width: 1210px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .common-footer {
    background: #e3e4e5 !important;
  }

  .username {
    font-size: .6rem;
    line-height: .6rem;
    color: #666;
  }
}

.foot {
  background: #f5f6f5;

  .copyright {
    width: 1210px;
    margin: 0 auto;
    font-size: $fontSize;
    color: #c5c5c5;
    text-align: center;
    padding: 1rem 0;

    .c-list {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }

    .item {
      padding: .4rem 0;
      margin: 0 .2rem 1rem 0;

      .t {
        // margin-bottom: .4rem;
        text-align: left;
        font-size: .6rem;
        color: #4b4b4b;
        font-weight: 600;
      }

      .text {
        cursor: pointer;
        text-align: left;
        font-size: .6rem;
        margin: .5rem 0;
        color: #7F7F7F;
      }
    }

    .icons {
      width: 31%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .icon {
        cursor: pointer;
        width: 1.5rem;
        height: 1.5rem;

        img {
          width: 100%;
          height: 100%;
          display: block !important;
        }
      }
    }

    .link {
      color: #c5c5c5
    }
  }
}

.item-wrap {
  position: relative;
  white-space: nowrap;
  margin: 0 .5rem;

  &:hover {
    .text {
      color: #e93b3d !important;
    }

  }

}

.image {
  width: 1rem;
  height: 1rem;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: .2rem;
  margin-bottom: .2rem;
}

.icon1 {
  position: absolute;
  right: 0.8rem;
  top: 0.2rem;
  font-size: $h6;
  line-height: 0.7rem;
  width: 0.9rem;
  height: 0.7rem;
  background: #ef3338;
  border-radius: 1rem;
  text-align: center;
  color: #ffffff;
}

img {
  display: none !important;
}

::v-deep(.mint-tabbar) {
  position: relative;
}
</style>
